export { formatAddress } from './address'
export { formatRouteTransitLegs } from './routes'
export { formatVehicles } from './vehicles'

export const formatSearchQuery = (searchQuery: string | null | undefined) =>
  searchQuery && searchQuery !== '' ? { searchQuery } : {}
